/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import {ListTable, Tip, Link, Button, Title, Group} from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './existingpayments_styles';

const paymenttypemap = {
  'CHECK': 'Check',
  'CHECKS': 'Check',
  'PAYPAL': 'PayPal',
  'ACH': 'Direct Deposit / ACH',
  'WIRE': 'Wire Transfer'
}

/* ========== ~~~~~~~~~~ EXISTING PAYMENTS  ~~~~~~~~~~ ========== */
const ExistingPayments = injectSheet(styles)((props) => {
  const { paymentInfo, viewPaymentDetails, addPaymentMethod } = props

  const handleTableData = () => {
    let dataArray = [];
    // changed this from map to forEach since we're not technically mapping anything here
    paymentInfo.forEach((item, index) => {
        if(item.paymentType !== 'NONE') dataArray.push({
            method: paymenttypemap[item.paymentType],
            lastupdate: item.lastUpdate,
            preferred: `${item.preferredPayment ? 'Yes' : 'No'}`,
            edit: <div className={`editcolumn`}><Link type={`action`} text={`Details`} color={`primary`} icon={`eye`} action={() => viewPaymentDetails(item)} /></div>
        })
    });
    return dataArray;
  }

  return (
    <div className={`existingpayments ${props.classes.existingpayments}`}>
        <Title variant={'withctas'}>
              <h2>Payment Method </h2>
              <Group name={`controls`}>
                <Button name={'addpaymentbtn'} variant={'primary'} text={'Add Payment Method'} handleClick={addPaymentMethod} />
              </Group>
          </Title>

        <ListTable
            name={`paymentmethod`}
            type={`standard`}
            size={`full`}
            columnHeads={{
                method: 'Payment Method',
                lastupdate: 'Last Update',
                preferred: <span>Preferred <Tip space={`none`} content={<p>This is the method that COOL Media will use to pay you.</p>}/></span>,
                edit: ''
            }}
            data={handleTableData()}
            rowsPerPage={'general'}
            paginationLocation={`bottom`}
        />
    </div>
  )
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ExistingPayments